/* Prepay upsell (Option C — deal-first modal) — loaded on the core-box prepay A/B templates
   (prepay-step2 / prepay-step2-v2).
   The prepay deal modal and the add-on popup work INDEPENDENTLY — either can be enabled alone:
   The deal ALWAYS intercepts the Order Now click BEFORE the native handler (capture phase); the
   native flow (incremental cart add, popup open, direct checkout) only runs after "No thanks" —
   so closing the deal leaves the PDP untouched (buy button live and enabled, cart clean).
   · Add-on popup ENABLED (2-step):
       Yes → arm prepay, open the add-on list directly · No → native flow (add-ons WITHOUT prepay).
       At the popup's Checkout / Skip / ×: prepay armed → build the synthetic-prepaid cart (box on PAYG
       "Every 4 Weeks" + prepay-balance qty tier-1; Skip = box only) preserving add-ons
       → /checkout?discount=PREPAY3BOX · not armed → the popup's normal checkout runs untouched.
   · Add-on popup DISABLED (1-step): the deal opens on the Order Now click instead.
       Yes → prepay checkout (box only) · No → the PDP's native direct checkout resumes.
   No backend change: the cart matches the handoff PDP, so Mechanic/Recharge draw-down is identical.
   Config (box variant -> PAYG plan id + prepay variant id + base price) is rendered server-side. */
(function () {
  'use strict';

  var cfgEl = document.querySelector('[data-prepay-upsell-config]');
  var overlay = document.querySelector('[data-prepay-step2]'); // the deal screen (step 1)
  if (!cfgEl || !overlay) return;

  var CONFIG;
  try { CONFIG = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  if (!CONFIG || !Array.isArray(CONFIG.boxes) || !CONFIG.boxes.length) return;
  if (!CONFIG.boxes.some(function (b) { return b.prepay != null; })) return; // feature unavailable → leave normal flow

  var tier = CONFIG.tier || 3;
  var priceLine = overlay.querySelector('[data-prepay-priceline]');
  var popup = document.getElementById('extra-products-popup'); // step 2 (add-on list)
  // The add-on popup is a separate feature toggled in the form-v2 block ("show_extra_products_popup" →
  // data-show). When it's off, the deal runs as a standalone 1-step modal off the Order Now click.
  var addonsEnabled = !!popup && popup.getAttribute('data-show') === 'true';
  var pendingBuyBtn = null; // 1-step mode: the buy button clicked while the deal is unresolved
  var wantPrepay = false;  // armed by "Yes" on the deal; applied at the step-2 checkout
  var dealHandled = false; // deal already shown + resolved this popup session
  var dealActive = false;  // deal currently on screen
  var submitting = false;

  function money(n) {
    n = Math.round(n * 100) / 100;
    return '$' + (n % 1 === 0 ? n.toFixed(0) : n.toFixed(2));
  }

  function selectedBox() {
    var input = document.querySelector('.product-form-v2 input[name="box-size"]:checked')
             || document.querySelector('input[name="box-size"]:checked');
    if (input) {
      var id = parseInt(input.value, 10);
      var hit = CONFIG.boxes.find(function (b) { return b.variantId === id; });
      if (hit) return hit;
    }
    return CONFIG.boxes[0];
  }

  function updatePrice() {
    var box = selectedBox();
    if (!box || !priceLine) return;
    var total = box.base * tier - (CONFIG.savings || 0);
    var perBox = total / tier;
    priceLine.innerHTML =
      '<s>' + money(box.base) + '</s>' +
      '<b>' + money(perBox) + '</b><span class="prepay-deal__unit">/box</span>' +
      '<span class="prepay-deal__today">' + money(total) + ' today for ' + tier + ' boxes</span>';
  }

  // ---- delivery helpers (mirror the handoff) ----
  function fmtYMD(date) {
    var y = date.getFullYear();
    var m = String(date.getMonth() + 1).padStart(2, '0');
    var d = String(date.getDate()).padStart(2, '0');
    return y + '-' + m + '-' + d;
  }
  // _NEXT_BILLING_DATE mirrors the native PDP rule (calculateNextBillingDate in product-form-v2_2.js):
  // ship + ONE cadence — the date box 2 bills. A post-checkout automation applies this to the
  // subscription's next charge when the first delivery is 7+ days out. It must NOT be tier cadences out:
  // the draw-down model needs charges 2..tier to occur on cadence ($0 box) — the draw-down expiring,
  // not a pushed charge date, is what makes box tier+1 the next paid one.
  function nextBillingDate(shipDate) {
    if (!shipDate) return null;
    var date = new Date(shipDate + 'T00:00:00');
    var min = new Date(); min.setDate(min.getDate() + 7);
    if (date < min) return null; // prompt shipping — Recharge's own cadence is already right
    date.setDate(date.getDate() + 4 * 7); // this deal's plan is fixed "Every 4 Weeks"
    return fmtYMD(date);
  }

  function clearCart() {
    return fetch('/cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json' } })
      .catch(function () { /* non-fatal */ });
  }

  function collectAddons(boxVariantId) {
    var out = [];
    var cards = document.querySelectorAll('.extra-products-popup .purchase-flow__product-card.active');
    cards.forEach(function (card) {
      var idEl = card.querySelector('[data-product-id]');
      var qtyEl = card.querySelector('.purchase-flow-step__quantity-selector input');
      if (!idEl) return;
      var pid = parseInt(idEl.getAttribute('data-variant-id'), 10);
      var qty = qtyEl ? parseInt(qtyEl.value, 10) : 1;
      if (!pid || !qty) return;
      out.push({ id: pid, quantity: qty, parent_id: boxVariantId, properties: { 'Type': 'Extra Item' } });
    });
    return out;
  }

  // Build the synthetic-prepaid cart and go to checkout. includeAddons=false for the Skip path.
  // single-addon popup mode: the one add-on being added, as a subscription line. Match its plan to the
  // prepay box cadence (Every 4 Weeks) so it ships with the box; fall back to the first available plan.
  function singleAddonLine(boxVariantId) {
    var btn = document.getElementById('extra-products-popup__single-addon-add');
    if (!btn) return null;
    var vid = parseInt(btn.getAttribute('data-variant-id'), 10);
    if (!vid) return null;
    var line = { id: vid, quantity: 1, parent_id: boxVariantId, properties: { 'Type': 'Extra Item' } };
    var plansEl = document.getElementById('extra-products-popup-addon-selling-plans');
    if (plansEl) {
      try {
        var plans = JSON.parse(plansEl.textContent) || [];
        var hit = plans.find(function (p) { return /every\s*4\s*weeks/i.test(p.name || ''); }) || plans[0];
        if (hit && hit.id) line.selling_plan = parseInt(hit.id, 10);
      } catch (e) { /* one-time add-on if plans can't be parsed */ }
    }
    return line;
  }

  // mode: 'collection' (grid add-ons) | 'single' (one subscription add-on) | 'none' (skip add-ons)
  function runPrepayCheckout(mode, btn) {
    if (submitting) return;
    var box = selectedBox();
    if (!box || box.prepay == null || box.payg == null) {
      alert('Sorry, the prepay option is unavailable right now. Please try again.');
      return;
    }
    submitting = true;

    var dvEl = document.querySelector('.item--first-delivery-value');
    var shipDate = dvEl ? dvEl.getAttribute('data-ship') : null;
    var range = dvEl ? (dvEl.textContent || '').trim() : null;
    var boxVariantId = box.variantId;

    var items = [{
      id: boxVariantId,
      selling_plan: box.payg,
      quantity: 1,
      properties: {
        'First Delivery Window': range,
        '_SHIP': shipDate,
        '_NEXT_BILLING_DATE': nextBillingDate(shipDate)
      }
    }];
    items.push({
      id: box.prepay,
      quantity: tier - 1,
      properties: { 'Covers': 'Boxes 2-' + tier + ' of your plan, prepaid today', '_PREPAID_TIER': tier }
    });
    if (mode === 'collection') {
      collectAddons(boxVariantId).forEach(function (it) { items.push(it); });
    } else if (mode === 'single') {
      var sa = singleAddonLine(boxVariantId);
      if (sa) items.push(sa);
    }

    var gift = document.querySelector('input[name="free_gift_products"]:checked');
    if (gift) {
      items.push({ id: parseInt(gift.value, 10), quantity: 1, parent_id: boxVariantId, properties: { 'Type': 'Free Gift' } });
    }

    var url = CONFIG.code ? ('/checkout?discount=' + encodeURIComponent(CONFIG.code)) : '/checkout';
    var btnHTML = btn ? btn.innerHTML : null;
    if (btn) { btn.disabled = true; btn.textContent = 'Checking out…'; }

    clearCart()
      .then(function () {
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items })
        });
      })
      .then(function (r) {
        if (!r.ok) { return r.json().then(function (e) { throw new Error(e.description || ('cart/add ' + r.status)); }); }
        return r.json();
      })
      .then(function () { window.location.href = url; })
      .catch(function (err) {
        console.error('[prepay-upsell-c] checkout failed', err);
        submitting = false;
        if (btn) { btn.disabled = false; if (btnHTML != null) btn.innerHTML = btnHTML; }
        alert('Sorry, something went wrong starting your checkout. Please try again.');
      });
  }

  // ---- step transitions ----
  function showDeal() {
    updatePrice();
    if (popup) popup.style.display = 'none';   // hide step 2 (add-ons) behind the deal
    overlay.hidden = false;
    dealActive = true;
    document.body.classList.add('popup-open');
  }
  function toAddons() {        // "Yes" (2-step): arm prepay → open the add-on list (step 2) OURSELVES
    // The native Order Now handler never ran (the deal intercepted the click), so the popup is opened
    // directly and the native cart add is skipped — correct, because with prepay armed EVERY exit from
    // the popup is intercepted below and runPrepayCheckout clears + rebuilds the cart itself.
    overlay.hidden = true;
    dealActive = false;
    dealHandled = true;
    pendingBuyBtn = null;
    if (popup) popup.style.display = 'block';
    document.body.classList.add('popup-open');
    document.documentElement.classList.add('html-popup-open');
  }
  function dismiss() {         // click-outside → close the whole thing, back to the PDP
    overlay.hidden = true;
    dealActive = false;
    dealHandled = false;       // so reopening the popup shows the deal again
    pendingBuyBtn = null;
    if (popup) popup.style.display = 'none';
    document.body.classList.remove('popup-open');
    document.documentElement.classList.remove('html-popup-open');
    // Defensive: if any native path disabled the buy button before the deal showed (incremental-cart
    // popup open), re-enable it — closing the deal must always leave Order Now clickable.
    var buyBtn = document.querySelector('.product-form-v2 .box-pdp__v2-form-add-to-cart') || document.querySelector('.box-pdp__v2-form-add-to-cart');
    if (buyBtn) buyBtn.disabled = false;
  }
  function resumeNativeCheckout() { // "No thanks" → re-dispatch the click so the native buy flow runs
    // 2-step: native handler adds to cart (incremental mode) and opens the add-on popup.
    // 1-step: native direct checkout.
    overlay.hidden = true;
    dealActive = false;
    dealHandled = true;          // capture guard below lets the re-dispatched click through
    document.body.classList.remove('popup-open');
    document.documentElement.classList.remove('html-popup-open');
    if (pendingBuyBtn) { var b = pendingBuyBtn; pendingBuyBtn = null; b.click(); }
  }
  // ---- wire up ----
  updatePrice();

  // 2-step mode: safety net + state reset. The deal normally intercepts the Order Now click below,
  // BEFORE the native handler — but if any other path makes the popup visible with the deal unresolved,
  // show the deal first (the callback runs as a microtask, before paint, so there's no flash of step 2).
  // The close branch resets state when the popup is dismissed without checking out.
  if (popup && addonsEnabled) {
    var mo = new MutationObserver(function () {
      var visible = getComputedStyle(popup).display !== 'none';
      if (visible) {
        if (dealHandled || dealActive) return;
        showDeal();
      } else if (!dealActive) {
        // Step 2 (the add-on popup) was closed by the shopper (×, Skip, or click-outside) without arming
        // prepay. Reset so the NEXT open shows the deal (step 1) again — otherwise "No thanks" followed by
        // closing would skip the deal on every later Order Now / variant change (and lose the prepay pitch).
        dealHandled = false;
        wantPrepay = false;
      }
    });
    mo.observe(popup, { attributes: true, attributeFilter: ['style', 'class'] });
  }

  // BOTH modes: the deal opens on the Order Now click, BEFORE the native handler (capture on document
  // runs ahead of the button's own listener in product-form-v2_2.js). Critical in the popup's
  // incremental-cart mode: the native handler disables the buy button and adds the box to the REAL
  // cart before showing the popup, and only re-enables on a checkout redirect — intercepting first
  // means closing the deal leaves the PDP untouched (button live, cart clean) instead of stuck, and
  // a re-opened deal can't double-add the box. After "No thanks", dealHandled lets the re-dispatched
  // click fall through to the native flow untouched.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.box-pdp__v2-form-add-to-cart');
    if (!btn || dealHandled || submitting) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    pendingBuyBtn = btn;
    showDeal();
  }, true);

  // Deal (step 1) controls.
  //   Yes → 2-step: arm prepay, open the add-on list directly · 1-step: prepay checkout now (box only).
  //   No  → re-dispatch the original click; the native flow runs untouched
  //         (2-step: cart add + add-on popup + its own checkout · 1-step: direct checkout).
  //   Click outside the card → close the modal entirely (back to the PDP), never advance.
  overlay.addEventListener('click', function (e) {
    e.stopPropagation();
    var yes = e.target.closest('[data-prepay-yes]');
    if (yes) {
      e.preventDefault();
      wantPrepay = true;
      if (addonsEnabled) { toAddons(); } else { runPrepayCheckout('none', yes); }
      return;
    }
    if (e.target.closest('[data-prepay-no]')) {
      e.preventDefault();
      wantPrepay = false;
      resumeNativeCheckout();
      return;
    }
    if (e.target === overlay) dismiss(); // backdrop → close, back to PDP
  });

  // 2-step mode only. Step 2 = the add-on list. With prepay armed, the commit/skip exits must still
  // build the prepay cart — otherwise they'd fall through to the popup's native checkout and drop the
  // prepay. The × close and click-outside are NOT commits:
  //   · #extra-products-popup__checkout-button → collections grid add-ons
  //   · #extra-products-popup__single-addon-add → the single subscription add-on
  //   · #extra-products-popup__skip → prepay, box only
  //   · #close-extra-products-popup → disarm + native close (back to the PDP; the cart is untouched in
  //     the armed flow, and the popup-close observer resets dealHandled so the next Order Now shows
  //     the deal again) · click-outside → nothing
  // Capture phase so we preempt product-form-v2_2.js. (When prepay isn't armed, the normal flow runs.)
  if (addonsEnabled) {
    document.addEventListener('click', function (e) {
      if (!wantPrepay) return;
      var btn = null, mode;
      if ((btn = e.target.closest('#extra-products-popup__checkout-button'))) mode = 'collection';
      else if ((btn = e.target.closest('#extra-products-popup__single-addon-add'))) mode = 'single';
      else if ((btn = e.target.closest('#extra-products-popup__skip'))) mode = 'none';
      else if (e.target.closest('#close-extra-products-popup')) { wantPrepay = false; return; } // × → native close
      else if (e.target === popup) return; // click outside the popup does nothing
      else return;
      e.preventDefault(); e.stopImmediatePropagation();
      runPrepayCheckout(mode, btn);
    }, true);
  }

  // Browser Back from checkout restores this page from the bfcache with JS state intact, so dealHandled
  // would still be true and the next Order Now would jump straight past the deal. Reset to a clean
  // PDP state on bfcache restore so step 1 (the deal) shows again.
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    wantPrepay = false;
    submitting = false;
    dealActive = false;
    dealHandled = false;
    pendingBuyBtn = null;
    overlay.hidden = true;
    if (popup) popup.style.display = 'none';
    document.body.classList.remove('popup-open');
    document.documentElement.classList.remove('html-popup-open');
  });
})();
